import { render } from "./GreenBook.vue?vue&type=template&id=2b9856d8&scoped=true"
import script from "./GreenBook.vue?vue&type=script&lang=js"
export * from "./GreenBook.vue?vue&type=script&lang=js"

import "./GreenBook.vue?vue&type=style&index=0&id=2b9856d8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9856d8"]])

export default __exports__